import yup from './yup';

const initialValues = {
  name: '',
  email: '',
  phone: '',
  topic: '',
  message: '',
  consent: false,
  token: '',
};

const validationSchema = yup.object().shape({
  name: yup.string().required('Bitte geben Sie Ihren Namen ein.'),
  email: yup.string().required('Bitte geben Sie Ihre E-Mail-Adresse ein.').email('Bitte geben Sie eine gültige E-Mail-Adresse ein.'),
  phone: yup.string().matches(/^[0-9+\s()-]{6,20}$/, 'Bitte geben Sie eine gültige Telefonnummer ein.'),
  topic: yup.string().required('Bitte geben Sie an, worum es geht.'),
  message: yup.string().required('Bitte geben Sie eine Mitteilung ein.'),
  consent: yup.bool().oneOf([true], 'Bitte stimmen Sie der Datenverarbeitung zu.'),
  token: yup.string().required('Bitte bestätigen Sie die Captcha Abfrage.'),
});

export default {
  initialValues,
  validationSchema,
};
